import React from 'react';

export default function SmileIcon(props) {
  return (
    <svg width={18} height={18} fill="none" {...props}>
      <g
        clipPath="url(#prefix__clip0_495_10566)"
        stroke="#3A3A49"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M9 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
          strokeWidth={1.5}
        />
        <path d="M6 10.5S7.125 12 9 12s3-1.5 3-1.5" strokeWidth={1.5} />
        <path d="M11.25 6.75h.008M6.75 6.75h.008" strokeWidth={2} />
      </g>
      <defs>
        <clipPath id="prefix__clip0_495_10566">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
